import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";
import {Title, Text, Grid, Container, Box, Card, TextInput, Textarea, Button, LoadingOverlay, Group, Badge} from "@mantine/core";
import BusinessIcon from '@mui/icons-material/Business';
import EmailIcon from '@mui/icons-material/Email';
import CallIcon from '@mui/icons-material/Call';
import RoomIcon from '@mui/icons-material/Room';
import { useState } from "react";
import { message, Alert } from "antd";



const Contactus = () => {
  const [Inputs, setinputs] = useState({
    Subject: 'This mail intended by GV InfoTech Contact us.',
    Name: '',
    Mobile_number: '',
    Email_ID: '',
    Message: ''
  });
  const [loading, setloading] = useState(false);
  const [showalert, setshowalert] = useState(false);
  const Handleinputchange = (e) => {
    const { name, value } = e.target;
    setinputs({ ...Inputs, [name]: value });
  }
  const Submit_Contact_us = async () => {
    const { Subject, Name, Mobile_number, Email_ID, Message } = Inputs;
    if (!Name || !Mobile_number || !Email_ID) {
      message.error("Please fill all required inputs");
      return;
    } else {
      setloading(true);
      const res = await fetch('https://formspree.io/f/xyzwalqn', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ Subject, Name, Mobile_number, Email_ID, Message })
      });

      if (res.status === 'ok' || res.status === 200) {
        message.success('Thanks form submitting contact form. We will be right back shortly!', 4);
        setinputs({
          Subject: 'This mail intended by GV InfoTech Contact us.',
          Name: '',
          Mobile_number: '',
          Email_ID: '',
          Message: ''
        });
        setloading(false);
        setshowalert(true);
        setTimeout(() => {
          setshowalert(false);
        }, 4000);
        return
      } else {
        message.error('oops! something went wrong.');
        setloading(false);
        return
      }
    }
  }
  return (
    <>
      <Navbar />
      {/* <div className="sky-container">
        <Image src={Skyimage} alt="header-img" h={200} />
        <div className="centered">Contact us</div>
      </div> */}
      <Group justify='center' mt={'xl'}>
        <Badge variant="outline" size="lg" p={'lg'} mt={'xl'} className='heading-pills'>
          Get In Touch
        </Badge>
      </Group>
      <Container mt={"xs"} size={"lg"} data-aos="fade-right">
        <Title ta={'center'} className='heading-as-text' size={'60'}>
          Talk to Our Experts
        </Title>
        <Group justify='center'>
          <Text c={'white'} fw={'bold'} className='heading-description' mt={'md'}>
            Ready to accelerate your digital transformation? Let's discuss your project and explore how we can help.
          </Text>
        </Group>
      </Container>
      <Container size={'lg'}>
        <Grid>
          <Grid.Col span={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
            {/* <Title mt={'xl'} c={'wheat'}>You tell, We listen!</Title> */}
            <Box mt={'xl'}>
              <Card shadow="sm" padding="lg" radius="md"  mt={'md'} className="heading-card">
                <BusinessIcon sx={{ fontSize: '50px', color: 'teal' }} />
                <Title c={'dimmed'} size={'lg'} mt={'md'}>Address</Title>
                <Text size="sm" c={'white'}>
                  Block-2 Shankar Market Connaught Place New Delhi
                </Text>
              </Card>
              <Card shadow="sm" padding="lg" radius="md"  mt={'md'} className="heading-card">
                <EmailIcon sx={{ fontSize: '50px', color: 'teal' }} />
                <Title c={'dimmed'} size={'lg'} mt={'md'}>Mail</Title>
                <Text size="sm" c={'white'}>
                  query.gvinfotech@gmail.com
                </Text>
              </Card>
              <Card shadow="sm" padding="lg" radius="md"  mt={'md'} className="heading-card">
                <CallIcon sx={{ fontSize: '50px', color: 'teal' }} />
                <Title c={'dimmed'} size={'lg'} mt={'md'}>Mobile Number</Title>
                <Text size="sm" c={'white'}>
                  (+91) 977- 387- 0841,
                  (+91) 770- 183- 6668
                </Text>
              </Card>
              <Card shadow="sm" padding="lg" radius="md"  mt={'md'} className="heading-card">
                <RoomIcon sx={{ fontSize: '50px', color: 'teal' }} />
                <Title c={'dimmed'} size={'lg'} mt={'md'}>Location</Title>
                <Text size="sm">
                  <div style={{ overflow: 'hidden', maxWidth: '100%', width: '500px', height: '200px' }}>
                    <div id="google-maps-display" style={{ height: '100%', width: '100%', maxWidth: '100%' }}>
                      <iframe
                        title="Google Map"
                        style={{ height: '100%', width: '100%', border: 0 }}
                        frameBorder="0"
                        src="https://www.google.com/maps/embed/v1/place?q=Shankar+Market,+New+Delhi,+Delhi,+India&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
                        allowFullScreen
                      />
                    </div>

                    {/* Optional external link - can be removed if not needed */}
                    {/* <a
                      className="google-map-html"
                      href="https://www.bootstrapskins.com/themes"
                      id="make-map-infor-mation"
                      style={{ display: 'none' }} // hide if not needed
                    >
                      premium bootstrap themes
                    </a> */}

                    {/* Inline style override (CSS-in-JS) */}
                    <style>
                      {`
          #google-maps-display img {
            max-height: none;
            max-width: none !important;
            background: none !important;
          }
        `}
                    </style>
                  </div>
                </Text>

              </Card>
            </Box>
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
            <Card shadow="sm" padding="lg" radius="md"  mt={90} className="heading-card">
              <Box pos="relative">
                <Alert message="Your form successfully submitted!" type="success" showIcon style={{ display: showalert ? 'flex' : 'none' }} />
                <LoadingOverlay
                  visible={loading}
                  zIndex={1000}
                  overlayProps={{ radius: 'sm', blur: 2 }}
                  loaderProps={{ color: 'indigo', type: 'bars' }}
                />
               <TextInput placeholder="Name (Required)" radius={'md'} name="Name" value={Inputs.Name} onChange={Handleinputchange} withAsterisk required mt={'xs'}  size="md"></TextInput>
                <TextInput placeholder="Mobile number (Required)" radius={'md'} name="Mobile_number" value={Inputs.Mobile_number} onChange={Handleinputchange} withAsterisk required mt={'lg'} minLength={10} maxLength={10} size="md"></TextInput>
                <TextInput placeholder="Email id (Required)" radius={'md'} name="Email_ID" value={Inputs.Email_ID} onChange={Handleinputchange} withAsterisk required mt={'lg'} size="md"></TextInput>
                <Textarea placeholder="Any message (Optional)" radius={'md'} mt={'lg'} size="md" name="Message" value={Inputs.Message} onChange={Handleinputchange} rows={3}></Textarea>
                <Button mt={'md'} size="lg" color="indigo" onClick={Submit_Contact_us} loading={loading} disabled={loading} variant="outline" fullWidth>Submit Form</Button>
              </Box>
            </Card>
          </Grid.Col>
        </Grid>
      </Container>
      <Footer />
    </>
  );
};

export default Contactus;
